import { render, staticRenderFns } from "./TkHotelCalendar.vue?vue&type=template&id=13ddf2a9&"
import script from "./TkHotelCalendar.vue?vue&type=script&lang=js&"
export * from "./TkHotelCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelCalendar.vue?vue&type=style&index=0&id=13ddf2a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports